import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreateReturnTypeErrorsMapper, CreateReturnTypeMapper } from '../mappers';
import { CreateReturnTypeDto } from '../dtos';

export type ICreateReturnTypeRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ICreateReturnTypeRepo = IRepo<[CreateReturnTypeDto, string | number | undefined], ICreateReturnTypeRepoResponse>;

export const CreateReturnTypeRepoType = Symbol.for('CreateReturnTypeRepo');

@bind(CreateReturnTypeRepoType)
export class CreateReturnTypeRepo implements ICreateReturnTypeRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreateReturnTypeDto) {
    try {
      const body = new FormData();
      const mappedBody = CreateReturnTypeMapper.toPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = dto.id ? urlMaker('/api/admin/return_reasons/edit') : urlMaker('/api/admin/return_reasons/create');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        const errors = CreateReturnTypeErrorsMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      console.error(e);
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
